import { Tag } from 'antd';

const StatusTag = ({
  status,
  onClick,
}: {
  status: string;
  onClick?: () => void;
}) => {
  const statusToColor: { [key: string]: string } = {
    NEW: '',
    DRAFT: '',
    CONFIRM: 'gold',
    APPROVED: 'green',
    READY: 'cyan',
    DONE: 'geekblue',
    CANCEL: 'red',
    DELAY: 'red',
    ON_TIME: 'green',
    NOT_DELIVERED: 'red',
    ISSUED: 'purple',
    AVAILABLE: 'cyan',

    NONE: '',
    INVENTORY_ONLY: '',
    PAYMENT_ONLY: '',
    PAYMENT_AND_INVENTORY: '',
  };

  const color = statusToColor[status] || '';
  return (
    <Tag
      onClick={onClick}
      color={color}
      key={status}
      style={{
        maxWidth: '300px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {status?.toUpperCase().replace('_', ' ')}
    </Tag>
  );
};

export default StatusTag;
